import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-y-8"
}

import { useFiltersStore } from "../stores/filters";
import { useProductsStore } from "../stores/products";
import FilterSection from "@js/components/filters/FilterSection.vue";
import SearchFilter from "@js/components/filters/SearchFilter.vue";
import CheckboxFilter from "@js/components/filters/CheckboxFilter.vue";
import ButtonFilter from "@js/components/filters/ButtonFilter.vue";
import RangeFilter from "@js/components/filters/RangeFilter.vue";
import NumberFilter from '@js/components/filters/NumberFilter.vue'
import LoadingIndicator from "@js/components/LoadingIndicator.vue";
import FilterPlaceholder from "./FilterPlaceholder.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductFilters',
  setup(__props) {

const store = useFiltersStore();
const productsStore = useProductsStore();

const filterTypes = {
  checkbox: {
    component: CheckboxFilter,
    props: ['options'],
  },
  number: {
    component: NumberFilter,
    props: ['min', 'max'],
  },
  range: {
    component: RangeFilter,
    props: [],
  },
  buttons: {
    component: ButtonFilter,
    props: ['options'],
  },
}

function getProps(section: ProductFilterSection) {
  const data = filterTypes[section.filterType];
  const props = {};
  data.props.forEach(function (prop: string) {
    if (prop === 'options') {
      props[prop] = store.filterData[section.categoryGroup];
    } else {
      props[prop] = section[prop];
    }
  });
  return props;
}

async function init() {
  await store.getFilters(true);
  productsStore.getProducts();
}

init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(store).filterSections && _unref(store).filterData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(FilterSection, { heading: "Søk blant husene" }, {
            default: _withCtx(() => [
              _createVNode(SearchFilter, {
                modelValue: _unref(store).searchQuery,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).searchQuery) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).filterSections, (section) => {
            return (_openBlock(), _createBlock(FilterSection, {
              key: section.id,
              heading: section.title,
              tooltip: section.tooltip
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(filterTypes[section.filterType].component), _mergeProps({ ref_for: true }, getProps(section), {
                  modelValue: _unref(store).filters[section.productFieldHandle],
                  "onUpdate:modelValue": ($event: any) => ((_unref(store).filters[section.productFieldHandle]) = $event)
                }), null, 16, ["modelValue", "onUpdate:modelValue"]))
              ]),
              _: 2
            }, 1032, ["heading", "tooltip"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_unref(store).filterSections === null && _unref(store).isLoading)
      ? (_openBlock(), _createBlock(FilterPlaceholder, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(LoadingIndicator, {
      "is-loading": _unref(store).filterSections !== null && _unref(store).isLoading
    }, null, 8, ["is-loading"])
  ]))
}
}

})